<template>
  <div>
    <!-- start: page -->
    <form class="ecommerce-form action-buttons-fixed" @submit.prevent="submitForm">
      <div class="row">
        <div class="col">
          <section class="card card-modern card-big-info">
            <div class="card-body">
              <div class="row">
                <div class="col-12">
                  <div class="form-group row align-items-center mb-3">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">CSV File</label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="file"
                        class="form-control form-control-modern"
                        ref="file"
                        accept=".csv"
                        required
                      />
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
      <div class="row action-buttons">
        <div class="col-12 col-md-auto">
          <button
            type="submit"
            class="
              submit-button
              btn btn-primary btn-px-4
              py-3
              d-flex
              align-items-center
              font-weight-semibold
              line-height-1
            "
            data-loading-text="Loading..."
          >
            <i class="bx bx-save text-4 me-2"></i> {{ translations.import }}
          </button>
        </div>
        <div class="col-12 col-md-auto px-md-0 mt-3 mt-md-0">
          <router-link class="cancel-button btn btn-light btn-px-4 py-3 border font-weight-semibold text-color-dark text-3" exact :to="{ name: 'Articles' }">
            {{ translations.cancel }}
          </router-link>
        </div>
        <!-- <div class="col-12 col-md-auto ms-md-auto mt-3 mt-md-0 ms-auto">
          <a href="#" class="delete-button btn btn-danger btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1">
            <i class="bx bx-trash text-4 me-2"></i> Delete Category
          </a>
        </div> -->
      </div>
    </form>
    <!-- end: page -->
  </div>
</template>

<script>
import { translations } from '@/mixins';
import api from '@/services/api';

export default {
  name: 'ImportArticles',
  mixins: [translations],
  methods: {
    submitForm() {
      const file = this.$refs.file.files[0];
      const formData = new FormData();
      formData.append('File', file);
      api.importArticles(formData)
        .then(() => {
          this.$toast.info('Artikli uspješno importirani');
          this.$router.push({ name: 'Articles' });
        })
        .catch((err) => this.$toast.error(err.response.data.info));
    },
  },
}
</script>
